export const OWNER_JARVIS_TURN_STORAGE_VERSION = 9;
export const OWNER_JARVIS_TURN_STORAGE_KEY = `wp-owner-jarvis-turn-v${OWNER_JARVIS_TURN_STORAGE_VERSION}`;
export const OWNER_JARVIS_TURN_TTL_MS = 12 * 60 * 60 * 1000;

const LEGACY_TURN_STORAGE_KEYS = Object.freeze(
  Array.from({ length: OWNER_JARVIS_TURN_STORAGE_VERSION - 1 }, (_, index) => `wp-owner-jarvis-turn-v${index + 1}`),
);

export function clearOwnerJarvisStoredTurns() {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.removeItem(OWNER_JARVIS_TURN_STORAGE_KEY);
    LEGACY_TURN_STORAGE_KEYS.forEach((key) => window.sessionStorage.removeItem(key));
  } catch { /* sessionStorage opcional */ }
}

export function readOwnerJarvisStoredTurn() {
  if (typeof window === "undefined") return null;
  try {
    // Puede haber dos conversaciones distintas después de convivir v4 (panel) y
    // v9 (runtime). Elegimos la escritura válida más reciente y la consolidamos
    // en la key vigente; no dejamos dos verdades activas después de esta lectura.
    const candidates = [OWNER_JARVIS_TURN_STORAGE_KEY, ...LEGACY_TURN_STORAGE_KEYS]
      .map((key) => {
        try {
          const raw = window.sessionStorage.getItem(key);
          if (!raw) return null;
          const parsed = JSON.parse(raw);
          const savedAt = Number(parsed?.savedAt || 0);
          if (!parsed?.turn || !savedAt || Date.now() - savedAt > OWNER_JARVIS_TURN_TTL_MS) return null;
          return { turn: parsed.turn, savedAt };
        } catch {
          return null;
        }
      })
      .filter(Boolean)
      .sort((a, b) => b.savedAt - a.savedAt);
    if (candidates.length) {
      const winner = candidates[0];
      window.sessionStorage.setItem(OWNER_JARVIS_TURN_STORAGE_KEY, JSON.stringify(winner));
      LEGACY_TURN_STORAGE_KEYS.forEach((key) => window.sessionStorage.removeItem(key));
      return winner.turn;
    }
    clearOwnerJarvisStoredTurns();
    return null;
  } catch {
    clearOwnerJarvisStoredTurns();
    return null;
  }
}

export function persistOwnerJarvisTurn(turn) {
  if (typeof window === "undefined") return;
  try {
    if (!turn) {
      clearOwnerJarvisStoredTurns();
      return;
    }
    window.sessionStorage.setItem(OWNER_JARVIS_TURN_STORAGE_KEY, JSON.stringify({ turn, savedAt: Date.now() }));
    LEGACY_TURN_STORAGE_KEYS.forEach((key) => window.sessionStorage.removeItem(key));
  } catch { /* sessionStorage opcional */ }
}
